import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d028d74"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]

import { ref } from 'vue';import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterItem',
  props: ['tag'],
  setup(__props) {

const props = __props

const store = useStore()


const isSelected = ref(false);

function toggleSelectFilter() {

    if (!isSelected.value) {

        console.log('toggle!');
        store.commit('addTagFilter', [props.tag.name]);

        isSelected.value = true;

    } else {

        console.log('toggle!');
        store.commit('removeTagFilter', [props.tag.name]);

        isSelected.value = false;

    }


}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["filter", { selected: isSelected.value}]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSelectFilter()))
  }, [
    _createElementVNode("img", {
      src: props.tag.img,
      alt: props.tag.name
    }, null, 8, _hoisted_1),
    _createElementVNode("p", null, _toDisplayString(props.tag.name), 1)
  ], 2))
}
}

})